import { render, staticRenderFns } from "./QuestionShow.vue?vue&type=template&id=0c7778fe&scoped=true&"
import script from "./QuestionShow.vue?vue&type=script&lang=ts&"
export * from "./QuestionShow.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionShow.vue?vue&type=style&index=0&id=0c7778fe&lang=less&scoped=true&"
import style1 from "./QuestionShow.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7778fe",
  null
  
)

export default component.exports